// Subject-count evidence is not person/owner identity verification.
const BODY_ESTIMATE_SOURCE_VERSION = 2;
function isBodyEstimateEligible(result, fileId = null) {
  if (!result || result.subject_count !== 1) return false;
  const named = result.photo_validation?.file_id;
  if (fileId != null && named != null && String(named) !== String(fileId)) return false;
  const session = result._session;
  if (!session) return true;
  const ids = session.file_ids;
  if (ids != null && (!Array.isArray(ids) || !ids.length
    || new Set(ids.map(String)).size !== ids.length
    || (fileId != null && !ids.map(String).includes(String(fileId))))) return false;
  const size = session.image_count ?? ids?.length ?? 1;
  if (!Number.isInteger(size) || size < 1 || (ids && ids.length !== size)) return false;
  const counts = session.subject_counts;
  // A combined estimate must never cross an unknown/zero/multi-subject image.
  if (size > 1 || counts !== undefined) {
    if (!Array.isArray(counts) || counts.length !== size || !counts.every(count => count === 1)) return false;
  }
  return true;
}
function sanitizeBodyEstimates(result, fileId = null) {
  if (!result || typeof result !== 'object' || isBodyEstimateEligible(result, fileId)) return result;
  return { ...result, subject_count: Number.isInteger(result.subject_count) && result.subject_count >= 0 ? result.subject_count : null, estimated_body_fat_range: null, estimated_body_fat: null,
    musculature_assessment: null, region_assessment: null, confidence: null,
    primary_visual_cues: [], custom_metrics: {} };
}
module.exports = { BODY_ESTIMATE_SOURCE_VERSION, isBodyEstimateEligible, sanitizeBodyEstimates };
